// src/utils/fetchSeoData.js
import axios from 'axios';

const API_KEY = "8c655bfc-a035-4b4c-af1a-39cf1a10bcdb";
const API_ENDPOINT = "https://api.collegeslike.com/api/seo/get";

export const fetchSeoData = async (page) => {
  try {
    const response = await axios.post(
      API_ENDPOINT,
      { page },
      { headers: { "x-api-key": API_KEY } }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching SEO data:", error);
    return { title: "Default Title", descriptions: "Default description" };
  }
};
